/**
 * @param prevData
 * @param newData
 * @returns {*&{questions: *[]}}
 */
const mergeQuestionsUtil = (prevData, newData) => {
  prevData = prevData || {}
  const combinedQuestions = [
    ...(prevData.questions || []),
    ...newData.questions
  ].reduce((unique, question) => {
    const exists = unique.find(q => q.id === question.id)
    if (!exists) {
      unique.push(question)
    }
    return unique
  }, [])

  return {
    ...newData,
    questions: combinedQuestions
  }
}

export default mergeQuestionsUtil
